var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueArow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7232 21.1484L20.8191 13.4704C20.9483 13.3243 21.0496 13.1521 21.1172 12.9636C21.2591 12.5897 21.2591 12.1704 21.1172 11.7965C21.0496 11.608 20.9483 11.4358 20.8191 11.2898L13.7232 3.61176C13.5908 3.46859 13.4338 3.35501 13.2609 3.27753C13.088 3.20004 12.9027 3.16016 12.7155 3.16016C12.3376 3.16016 11.9751 3.3226 11.7079 3.61176C11.4407 3.90092 11.2905 4.29311 11.2905 4.70204C11.2905 5.11098 11.4407 5.50316 11.7079 5.79232L16.3913 10.8445L4.20037 10.8445C3.82398 10.8445 3.46299 11.0063 3.19684 11.2942C2.93069 11.5822 2.78117 11.9728 2.78117 12.3801C2.78117 12.7873 2.93069 13.1779 3.19684 13.4659C3.46299 13.7539 3.82398 13.9157 4.20037 13.9157L16.3913 13.9157L11.7079 18.9678C11.5749 19.1106 11.4693 19.2804 11.3973 19.4675C11.3252 19.6547 11.2881 19.8554 11.2881 20.0581C11.2881 20.2608 11.3252 20.4615 11.3973 20.6487C11.4693 20.8358 11.5749 21.0056 11.7079 21.1484C11.8398 21.2923 11.9968 21.4066 12.1697 21.4845C12.3427 21.5625 12.5282 21.6026 12.7155 21.6026C12.9029 21.6026 13.0884 21.5625 13.2613 21.4845C13.4343 21.4066 13.5912 21.2923 13.7232 21.1484Z",
    fill: "#1865C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueArow1);
export default __webpack_public_path__ + "static/media/blue-arow-1.bbcf7bcf9c47982e63e6d6f473efff75.svg";
export { ForwardRef as ReactComponent };